import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-palette1 text-white justify-center items-center flex flex-col lg:flex-row space-y-2 lg:space-y-0 lg:space-x-2 py-2" }
const _hoisted_2 = { class: "flex space-x-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "enjoying the app?", -1)
const _hoisted_4 = { class: "flex space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "donate", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "underline",
  href: "https://www.buymeacoffee.com/jaroslawweber"
}, " here ", -1)
const _hoisted_7 = { key: 0 }

import { isMobileScreen } from "@/screenSize";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isMobile = isMobileScreen();

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        icon: "heart",
        size: "lg"
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_font_awesome_icon, {
        icon: "donate",
        size: "lg"
      }),
      _hoisted_5,
      _hoisted_6,
      (!_unref(isMobile))
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "to support me!"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})